/*
  5s-quote-card.js — "Add to quote" on product cards (snippets/5s-card.liquid).
  Shown for products on the quote template. Saves to the same localStorage list
  ('5s_quote') as sections/5s-product-quote.liquid, read by sections/5s-quote-request.liquid.
  Loaded once per card; the guard below makes it run only once per page.
*/
(function () {
  if (window.__fiveSQuoteCard) return;
  window.__fiveSQuoteCard = true;

  var KEY = '5s_quote';
  var modal = null;

  function load() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }

  function save(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('quote:updated', { detail: { count: list.length } }));
  }

  function buildModal() {
    var style = document.createElement('style');
    style.textContent =
      '.qc-modal{width:min(440px,calc(100vw - 32px));padding:28px 24px 24px;border:0;border-radius:var(--t-r,10px);box-shadow:var(--t-sh-lg,0 12px 32px rgba(20,22,24,.12));text-align:center;color:var(--t-ink-2,#2A2E33)}' +
      '.qc-modal::backdrop{background:rgba(20,22,24,.45)}' +
      '.qc-modal p{margin:0 0 20px;font-size:14.5px;line-height:1.55}' +
      '.qc-modal p b{color:var(--t-ink,#141618)}' +
      '.qc-modal__btns{display:grid;grid-template-columns:1fr 1fr;gap:10px}' +
      '.qc-modal__btn{display:flex;align-items:center;justify-content:center;min-height:44px;padding:10px 14px;border:1.5px solid var(--t-ink,#141618);border-radius:var(--t-r-sm,6px);background:#fff;color:var(--t-ink,#141618);font:inherit;font-size:14px;font-weight:700;text-decoration:none;cursor:pointer}' +
      '.qc-modal__btn:hover{background:var(--t-surface,#F4F6F8)}' +
      '.qc-modal__btn.is-dark{background:var(--t-ink,#141618);color:#fff}' +
      '.qc-modal__btn.is-dark:hover{background:#000}' +
      '@media (max-width:749px){.qc-modal__btns{grid-template-columns:1fr}}';
    document.head.appendChild(style);

    modal = document.createElement('dialog');
    modal.className = 'qc-modal';
    modal.setAttribute('aria-label', 'Added to quote');
    modal.innerHTML =
      '<p>The product <b data-qc-title></b> is added to your quote.</p>' +
      '<div class="qc-modal__btns">' +
        '<button type="button" class="qc-modal__btn is-dark" data-qc-close>Continue Shopping</button>' +
        '<a class="qc-modal__btn" data-qc-view href="/pages/request-for-quote">View Quote</a>' +
      '</div>';
    document.body.appendChild(modal);

    modal.querySelector('[data-qc-close]').addEventListener('click', function () { modal.close(); });
    modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-pc-quote]');
    if (!btn) return;
    e.preventDefault();

    var d = btn.dataset;
    var id = parseInt(d.id, 10);
    var list = load();
    var found = list.filter(function (it) { return it.id === id; })[0];
    if (found) {
      found.qty = (parseInt(found.qty, 10) || 1) + 1;
    } else {
      list.push({
        id: id,
        title: d.title,
        variant: d.variant || '',
        sku: d.sku || '',
        url: d.url + '?variant=' + id,
        image: d.img || '',
        qty: 1
      });
    }
    save(list);

    var quoteUrl = d.quoteUrl || '/pages/request-for-quote';
    if (!window.HTMLDialogElement) { window.location.href = quoteUrl; return; }
    if (!modal) buildModal();
    modal.querySelector('[data-qc-title]').textContent = d.title;
    modal.querySelector('[data-qc-view]').href = quoteUrl;
    modal.showModal();
  });
})();
